// frontend/src/utils/mockAuth.js
// Sistema de autenticación simulado para demo

import { DEMO_USERS } from './mockData';

const DEMO_SESSION_KEY = 'demo_session';
const DEMO_MODE_KEY = 'demo_mode';

// Activar modo demo
export function enableDemoMode() {
  localStorage.setItem(DEMO_MODE_KEY, 'true');
}

// Verificar si está en modo demo
export function isDemoMode() {
  // Siempre en modo demo para esta versión
  return true;
}

// Simular login
export async function demoLogin(email, password) {
  // Simular delay de red
  await new Promise(resolve => setTimeout(resolve, 800));

  const user = DEMO_USERS[email.toLowerCase()];
  
  if (!user) {
    throw new Error('Usuario no encontrado. Prueba con admin@demo.com, jefe@demo.com o colaborador@demo.com');
  }

  if (user.password !== password) {
    throw new Error('Contraseña incorrecta. La contraseña demo es: demo123');
  }

  // Crear sesión demo
  const session = {
    user: {
      id: user.id_usuario,
      email: user.email,
      user_metadata: { name: user.nombre }
    },
    access_token: `demo_token_${user.id_usuario}_${Date.now()}`,
    expires_at: Date.now() + (24 * 60 * 60 * 1000) // 24 horas
  };

  // Guardar sesión
  localStorage.setItem(DEMO_SESSION_KEY, JSON.stringify(session));
  enableDemoMode();

  return { data: session, error: null };
}

// Obtener sesión actual
export function getDemoSession() {
  try {
    const sessionStr = localStorage.getItem(DEMO_SESSION_KEY);
    if (!sessionStr) return null;

    const session = JSON.parse(sessionStr);
    
    // Verificar expiración
    if (session.expires_at < Date.now()) {
      clearDemoSession();
      return null;
    }

    return session;
  } catch {
    return null;
  }
}

// Obtener usuario actual
export function getDemoUser() {
  const session = getDemoSession();
  if (!session) return null;

  const email = session.user?.email;
  return DEMO_USERS[email] || null;
}

// Cerrar sesión demo
export function clearDemoSession() {
  localStorage.removeItem(DEMO_SESSION_KEY);
  localStorage.removeItem('userId');
  localStorage.removeItem('userName');
  localStorage.removeItem('userRole');
  localStorage.removeItem('userRoleId');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('userRut');
  localStorage.removeItem('userEstado');
  localStorage.removeItem('userEmpresaId');
}

// Obtener token de acceso
export function getDemoToken() {
  const session = getDemoSession();
  return session?.access_token || null;
}

// Verificar si hay sesión activa
export function hasDemoSession() {
  return getDemoSession() !== null;
}

// Refrescar sesión (simular)
export async function refreshDemoSession() {
  const session = getDemoSession();
  if (!session) return { data: null, error: new Error('No session') };

  // Extender expiración
  session.expires_at = Date.now() + (24 * 60 * 60 * 1000);
  localStorage.setItem(DEMO_SESSION_KEY, JSON.stringify(session));

  return { data: { session }, error: null };
}

// Cliente Supabase mock
export const mockSupabaseAuth = {
  signInWithPassword: async ({ email, password }) => {
    return demoLogin(email, password);
  },

  getSession: async () => {
    const session = getDemoSession();
    return { data: { session }, error: null };
  },

  getUser: async () => {
    const session = getDemoSession();
    if (!session) return { data: { user: null }, error: null };
    return { data: { user: session.user }, error: null };
  },

  refreshSession: async () => {
    return refreshDemoSession();
  },

  signOut: async () => {
    clearDemoSession();
    return { error: null };
  },

  onAuthStateChange: (callback) => {
    // Simular listener
    const checkSession = () => {
      const session = getDemoSession();
      callback(session ? 'SIGNED_IN' : 'SIGNED_OUT', session);
    };
    
    // Llamar inmediatamente
    setTimeout(checkSession, 100);

    // Retornar función de limpieza
    return {
      data: {
        subscription: {
          unsubscribe: () => {}
        }
      }
    };
  }
};
